import ActivitiesCreate from './ActivitiesCreate';

export default ActivitiesCreate;
